import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[sectionDirective]',
    standalone: false
})
export class SectionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
